(function () {
    'use strict';


    angular.module('swif.framework')
    .factory('swifEmailService', swifEmailService);


    /**
     * @ngdoc service
     * @name swif.framework.swifEmailService
     * @requires swif.framework.dataService
     * @requires swif.framework.collections
     * @requires swif.framework.settingsService
     * @description

     * To use the webmail you just have to provide an action:
     * ```
        {
            "id": "webmail",
            "title": "eMail",
            "icon": "envelope-o",
            "visible": true,
            "available": "hasAction(o, 'update')",
            "btn": {
                "class": "ng-hide",
                "cancelLabel": "Close"
            },
            "modal": {
                "title": "Webmail",
                "templateUrl": "partials/ui/webmail_modal.html",
                "size": "lg"
            }
        }
     * ```
     */
    function swifEmailService($q, dataService, collections, settingsService) {
        'ngInject';
        var settings = settingsService;
        var service = {};
        service.getEmailFilter = function (item) {
            let deferred = $q.defer();
            let filter = {};
            if (item) {
                // Sort emails for all webmail's views
                dataService.sortOn(filter, 'create_date', 'DESC');
                var model = settings.getContentType(item._type).model;
                if (model == 'openstc.ask') {
                    updateMailFilters('ask_id', 'openstc.ask.transfer', 'intervention_request_transfer', item, filter, model).then(() => {
                        deferred.resolve(filter)
                    });
                } else if(model == 'project.project') {
                    updateMailFilters('inter_id', 'project.project.transfer', 'intervention_transfer', item, filter, model).then(() => {
                        deferred.resolve(filter)
                    });
                } else {
                    dataService.addExtraFilter(filter, 'context', 'model', '=', model);
                    dataService.addExtraFilter(filter, 'context', 'res_id', '=', item.id);
                    deferred.resolve(filter);
                }
            }
            return deferred.promise;
        };

        function updateMailFilters(column, table, content_type, item, filter, model) {
            let transferFilter = { fields: ['id'] };
            dataService.addFilter(transferFilter, column, '=', item.id);
            return dataService.searchRead(content_type, transferFilter).then(transfers => {
                let transferIds = transfers.records.map(tr => tr.id);
                dataService.addExtraFilter(filter, 'context', '|');
                dataService.addExtraFilter(filter, 'context', '&');
                dataService.addExtraFilter(filter, 'context', 'model', '=', model);
                dataService.addExtraFilter(filter, 'context', 'res_id', '=', item.id);
                dataService.addExtraFilter(filter, 'context', '&');
                dataService.addExtraFilter(filter, 'context', 'model', '=', table);
                dataService.addExtraFilter(filter, 'context', 'res_id', 'in', transferIds);
            })
        }

        service.createEmailCollection = function (id, item) {
            /**
             * {"jsonrpc":"2.0","method":"call","params":{"model":"mail.message","fields":["date","subject","email_from","user_id","fetchmail_server_id","message_id","partner_id","state"],"domain":["|",["state","in",["outgoing","exception"]],["email_from","!=",false]],"context":{"__ref":"compound_context","__contexts":[{"lang":"fr_FR","project_id":false,"tz":"Europe/Paris","uid":1},{"bin_size":true}],"__eval_context":null},"sort":"","offset":0,"limit":80,"session_id":"18469783ff9f4ec18901d56fdb6c17f5"},"id":"r142"}
             * @type {[type]}
             */
            return service.getEmailFilter(item).then(filter => {
                return collections.createOrUpdate(
                    id, 'mail_message', filter
                );
            });
        };
        service.createMailMessage = function (m, context) {
            return dataService.create('mail_message', m, context);
        };
        service.schedule_with_attach = function (m, context) {
            return dataService.callKw(
                'mail_message', 'schedule_with_attach',
                [m.email_from, [m.email_to], m.subject, m.body_text],
                {model: m.model, res_id: m.res_id, context: context}
            );
        };
        service.send = function (id) {
            return dataService.call('mail_message', 'send', [[id]])
            .then(function() {
                return id;
            });
        };
        return service;
    }



})();
